import React, { useEffect } from "react";

import Header from "./Header";
import { login, logout, selectUser } from "./features/userSlice";
import Feed from "./Feed";
import Sidebar from "./Sidebar";
import { useDispatch, useSelector } from "react-redux";
import Widgets from "./Widgets";
import Login from "./Login";
import { auth } from "./firebase";
import "./App.css";

function App() {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  useEffect(() => {
    auth.onAuthStateChanged((userAuth) => {
      if (userAuth) {
        // user is logged in
        dispatch(
          login({
            email: userAuth.email,
            uid: userAuth.uid,
            displayName: userAuth.displayName,
            photoURL: userAuth.photoURL,
          })
        );
      } else {
        //user is logged out
        dispatch(logout({}));
      }
    });
  }, []);

  return (
    <div className="app">
      <Header />
      {!user ? (
        <Login />
      ) : (
        <div className="app__body">
          <Sidebar />
          <Feed />
          <Widgets />
        </div>
      )}
    </div>
  );
}

export default App;
